import { forwardRef, HTMLAttributes } from 'react'

import Button from '@/components/base/button'

export type BurgerProps = HTMLAttributes<HTMLButtonElement> &
  Partial<{
    open: boolean
    onClick: () => void
  }>

const Burger = forwardRef<HTMLButtonElement, BurgerProps>(
  ({ open, className, onClick, ...props }, ref) => {
    return (
      <Button
        asChild
        isLiquid
        variant="accent"
        className="[&_svg[data-background]]:fill-text-menu-light [&_svg[data-background]]:stroke-border-menu-light"
      >
        <button onClick={onClick} ref={ref} className={className} {...props}>
          {open ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="17"
              viewBox="0 0 18 17"
              className="!fill-text-accent-light !stroke-none"
            >
              <path d="M4.96 4.46a1.14 1.14 0 0 1 1.62 0L9 6.88l2.42-2.42a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L10.62 8.5l2.42 2.42c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0L9 10.12l-2.42 2.42c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L7.38 8.5 4.96 6.08a1.14 1.14 0 0 1 0-1.62Z" />
            </svg>
          ) : (
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="!stroke-text-accent-light stroke-2"
            >
              <path d="M1 4.35352H17" strokeLinecap="round" />
              <path d="M1 8.92578H17" strokeLinecap="round" />
              <path d="M1 13.498H17" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </Button>
    )
  }
)

export default Burger
